import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonElevated } from '@snack-uikit/button';
import { ChevronDownSVG, ChevronLeftSVG, ChevronRightSVG, ChevronUpSVG } from '@snack-uikit/icons';
import { TYPE } from '../../constants';
import styles from './styles.module.css';
const MAP_TYPE_TO_ICON_SIZE = {
    [TYPE.Primary]: 's',
    [TYPE.Secondary]: 'xs',
};
const MAP_DIRECTION_TO_ICON = {
    left: _jsx(ChevronLeftSVG, {}),
    right: _jsx(ChevronRightSVG, {}),
    top: _jsx(ChevronUpSVG, {}),
    bottom: _jsx(ChevronDownSVG, {}),
};
export function ScrollButton({ type, onClick, direction, orientation }) {
    return (_jsx("div", { className: styles.scrollButton, "data-direction": direction, "data-type": type, "data-orientation": orientation, "data-test-id": `tabs__scroll-button-${direction}`, children: _jsx(ButtonElevated, { tabIndex: -1, icon: MAP_DIRECTION_TO_ICON[direction], size: MAP_TYPE_TO_ICON_SIZE[type], onClick: onClick }) }));
}
